import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { actions } from 'app/redux/modules/form';
import { Container, Description, Link } from './Resend.style';

class ResendLink extends React.PureComponent {
  static propTypes = {
    timeToResend: PropTypes.number,
    requestCode: PropTypes.func
  };

  resendCode = ev => {
    ev.preventDefault();
    this.props.requestCode();
  };

  render() {
    const { timeToResend } = this.props;

    if (timeToResend === 0) {
      return (
        <Container>
          <Description>Не пришел код?</Description>
          <Link onClick={this.resendCode}>Отправить повторно</Link>
        </Container>
      );
    }
    return (
      <Description>
        Код выслан, получить код повторно можно будет через{' '}
        {timeToResend / 1000} сек.
      </Description>
    );
  }
}

export default connect(
  state => ({
    timeToResend: state.form.timeToResend
  }),
  actions
)(ResendLink);
